import { takeLatest, put, take } from 'redux-saga/effects';
import get from 'lodash/get';

import { SURVEYS_TYPES } from '../constants';
import { QUESTION_TYPES } from '../../../constants/props';
import * as appointmentConsent from '../appointment-consent-req';

function* consentSagaWorker({ payload }) {
  const { settings, assignmentId, targetUserId } = payload || {};
  const name = get(settings, 'name');
  let url = null;

  if (name === QUESTION_TYPES.appointmentConsent) {
    const appointmentConsentId = get(settings, 'meta.consentDescription.id');

    yield put(
      appointmentConsent.actions.send({
        assignmentId,
        userId: targetUserId,
        appointmentConsentId,
      }),
    );
    const response = yield take(appointmentConsent.consts.SUCCEED);
    url = get(response, 'payload.pdfFileUrl');
  }
  if (name === QUESTION_TYPES.consent) {
    url = get(settings, 'meta.consentDescription.fileUrl', null);
  }

  if (url) window.open(url, '_blank');
}

export default function* consentSaga() {
  yield takeLatest(SURVEYS_TYPES.LINK_CONSENT, consentSagaWorker);
}



// WEBPACK FOOTER //
// ./src/redux/surveys/sagas/consent-saga.js